import React from 'react';
import CapacityPlantTemplate from '../../components/CapacityPlantTemplate';
import { capacityPlants } from '../../data/capacityPlants';

const WaterPlant30BPM = () => (
  <CapacityPlantTemplate plant={capacityPlants['/30-bpm-water-plant']} path="/30-bpm-water-plant" />
);

export default WaterPlant30BPM;
